import { IWordingsState } from './wordingsContext';
import { TWordingsAction, WordingsActionsTypes } from './wordingsActions';

export const wordingsReducer = (state: IWordingsState, action: TWordingsAction): IWordingsState => {
	switch (action.type) {
		case WordingsActionsTypes.SET_ALL_DATA:
			return {
				...state,
				groups: action.payload.groups,
			};
		case WordingsActionsTypes.SET_GROUP:
			return {
				...state,
				selectedGroup: action.payload.selectedGroup,
			};
		case WordingsActionsTypes.SET_LANGUAGE:
			return {
				...state,
				selectedLanguage: action.payload.selectedLanguage,
			};
		case WordingsActionsTypes.SET_AVAILABLE_LANGUAGES:
			return {
				...state,
				availableLanguages: action.payload.availableLanguages,
			};
		case WordingsActionsTypes.ADD_INVALID_FIELD:
			return {
				...state,
				invalidFields: [...state.invalidFields, action.payload.invalidField],
			};
		case WordingsActionsTypes.CLEAR_INVALID_FIELDS:
			return {
				...state,
				invalidFields: [],
			};
		case WordingsActionsTypes.REMOVE_WORDING:
			return {
				...state,
				groups: action.payload.groups,
			};
		case WordingsActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case WordingsActionsTypes.SET_DELETE_WORDING_DATA:
			return {
				...state,
				deleteWordingData: action.payload.deleteWordingData,
			};
		case WordingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
